app = {
	
	dispatcher :  new Dispatcher(),
	initialized : false,
	NOGL : false,
	filmReleased:'',	
	
	init:function(){
		//alert('app.init()');
		this.bindEvents();

		app.overlay = new OverlayView(app.dispatcher);
		app.utils = new Utils();
		app.scene = new World( app.dispatcher );
		app.mens = new ShareImageGen( app.dispatcher );
		app.navBar = new NavBar( app.dispatcher );
		app.uiView = new UIView( app.dispatcher );
		app.soundManager = new SoundManager( app.dispatcher );
		app.vis = new VisChange(app.dispatcher);
		app.tracking = new Tracking( app.dispatcher );
		ani.init();

		if( app.utils.checkURLHash() ){
		
			app.userMessage = app.utils.getHashMessage();
			var data = {};
			data.message = app.userMessage;
		}	
				
	},

	bindEvents : function(){

		FastClick.attach(document.body);//Add fastclick
	
		app.dispatcher.addEventListener( EVENTS.SHARE_IMAGE_READY_FB , app.onShareImageReadyFB );//360 or tw image are raedy
		app.dispatcher.addEventListener( EVENTS.SHARE_IMAGE_FB_DONE , app.onShareFBDone );	//360 image shared
		app.dispatcher.addEventListener( EVENTS.SHARE_IMAGE_TW_DONE , app.onShareFBDone );
		app.dispatcher.addEventListener( EVENTS.SHOW_SHARE , app.onShowShare );
		window.addEventListener("orientationchange" , app.onOrientationChange );
		
		if(Detectizr.os.name === 'android'){
			window.addEventListener("resize" , app.checkAndroidKeyboard );

		}

	},

	imageGen : function(){
		this.dispatcher.dispatch( EVENTS.TRACKING_CLICK, localisation.site.tracking.actions.click.facebook );

		this.dispatcher.dispatch( EVENTS.TOGGLE_RENDER, { pause : true } );
		var data = {
			message : app.userMessage,
			type : 0
		};

		$(dom.fbUpload.container).addClass("is-active");
		$(dom.share.status_copy).html("");
		$(dom.share.status_copy).html(localisation.site.messages.uploading);

		 
		//localisation.uploading_complete 
		//localisation.uploading_error
		app.dispatcher.dispatch(EVENTS.SHARE_IMAGE,data);
		app.dispatcher.dispatch( EVENTS.TAB_SOUND );
	},


	
	onShareImageReadyFB : function( event, data ){

		FacebookUpload.uploadImage(data.img,"test");
	},

	onShareFBDone : function(event,data){
		if(data === "success"){
			$(dom.share.status_copy).html( localisation.site.messages.uploading_complete );
		}else{
			if(data === "blocked")	$(dom.share.status_copy).html( localisation.site.messages.popUpBlock );
			else $(dom.share.status_copy).html( localisation.site.messages.uploading_error );
		}
		TweenMax.delayedCall(2,function(){
			$(dom.fbUpload.container).removeClass( "is-active" );
			app.dispatcher.dispatch( EVENTS.TOGGLE_RENDER, { pause : false } );
		});
	},


	onOrientationChange : function(event){
		app.dispatcher.dispatch(EVENTS.RESIZE)
		app.checkOrientation( false );
	},
	onShowShare : function(){
		app.locationQuery('add', app.base64encode); 

		var button = document.getElementById( dom.share.copyLink.substring(1) );
		button.setAttribute('data-clipboard-text',window.location.href);
	},

//////////////////////////////////////////////
//! Message Functions
//////////////////////////////////////////////

	locationQuery:function(type, query) {
		
		var siteAddress = window.location.protocol + "//" + window.location.host + window.location.pathname;
		
		if (type === 'get') {
			
			query = window.location.replace(siteAddress+'#', '');
			
			return query;
		}
		
		else if (type === 'add') {
			
			var newurl = siteAddress + '#'+ query;
			
				window.history.pushState({path:newurl},'',newurl);
			
			//window.location = siteAddress + '?' + query;
		}
		
		else if (type === 'remove') {
			
			window.history.pushState({path:siteAddress},'',siteAddress);
		}
	},
	
	uploadToTwitter : function(){
		var data = {
			message :  "lorem impsum",
			type : 1
		};
		$(dom.fbUpload.container).addClass("is-active");
		app.dispatcher.dispatch(EVENTS.SHARE_IMAGE,data);
	},

	submitMessage:function(){
		app.userMessage = $(dom.write.input).val();

		if(app.utils.checkProfanity(app.userMessage)){
				//remove jump lines multi spaces 
				app.userMessage = app.userMessage.replace(/(\r\n|\n|\r)/gm," "); //
				app.userMessage =  app.userMessage.replace(/\s\s+/g, ' ');
				if(app.userMessage.charAt(0) == " "){
					app.userMessage = app.userMessage.substring(1);
				}
				//app.userMessage = app.userMessage.replace(/\s/, '');
				//app.userMessage = app.userMessage.replace(/\t/, '');
				//app.userMessage = app.userMessage.replace(/\t/, '');
				if ( app.userMessage.length === 0 ){
					$(dom.write.emptyError).addClass('is-active');
					$(dom.write.profanityError).removeClass('is-active');
					$(dom.write.emojiError).removeClass('is-active');
					$(dom.write.box).addClass('is-error');
					return;
				}	
				if (!app.userMessage.replace(/\s/g, '').length) {
					$(dom.write.emptyError).removeClass('is-active');
					$(dom.write.profanityError).removeClass('is-active');
					$(dom.write.emojiError).addClass('is-active');
					$(dom.write.box).addClass('is-error');
					return;
				}

				if(app.processString(app.userMessage)){
					page.change('preview');
					$(dom.write.emptyError).removeClass('is-active');
					$(dom.write.profanityError).removeClass('is-active');
					$(dom.write.emojiError).removeClass('is-active');
					$(dom.write.box).removeClass('is-error');
					$(dom.page.preview + ' h1').html(app.userMessage);
					
				}else{
					$(dom.write.profanityError).removeClass('is-active');
					$(dom.write.emptyError).removeClass('is-active');
					$(dom.write.emojiError).addClass('is-active');
					$(dom.write.box).addClass('is-error');
					
				}
				
				
			} else {
				$(dom.write.box).addClass('is-error');
				$(dom.write.profanityError).addClass('is-active');
				$(dom.write.emptyError).removeClass('is-active');
				$(dom.write.emojiError).removeClass('is-active');
			}
			
	},
	
	recieveMessage:function(queryString){
		//Decode the message
		var message = app.utils.decodeString(queryString);
		//Do stuff
		$(dom.page.recieved + ' h1').html(message);
	},
	
	processString:function(string){
		// save the base64 string conversion
		app.base64encode = app.utils.encodeString(string);
		if(app.base64encode)return true
		else return false;
		
	},
	

	checkOrientation : function(firstLoad){
		if ( (window.orientation === 0) || (window.orientation === 180) ){
			app.screenHeight = window.innerHeight;
			if(!firstLoad){
				ani.orientationAnim.reverse();
			}
		}else{
			ani.orientationAnim.play();
		}
	},
	checkAndroidKeyboard : function(){
		if(app.screenHeight > window.innerHeight){
			app.keyboardOn = true;	
			
			
			TweenMax.to(dom.titles,0.2,{ y:-500})

			TweenMax.to(dom.navBar.bar,0.2,{ y:500})
			TweenMax.to(dom.write.box,0.2,{ scale:0.7})
		}
		else{
			app.keyboardOn = false;
			TweenMax.to(dom.titles,0.1,{ y:00})
			TweenMax.to(dom.navBar.bar,0.1,{ y:0})
			TweenMax.to(dom.write.box,0.1,{ scale:1})
		}
		app.screenHeight = window.innerHeight;
	}



};

if (window.canLoad) {
	window.onload = preload.init;
}

	( function(){ Math.clamp = function( a, b, c ){ return Math.max( b, Math.min( c, a ) );}; } )();

/*---------------------------------------------------
	SCOPE FUNCTION
--------------------------------------------------*/
	Function.prototype.bindX = function(scope) {
		var _function = this;
	
		return function() {
			return _function.apply(scope, arguments);
		};
	
	};	